/* eslint-disable @typescript-eslint/no-explicit-any */
type IHandleField= (values : {[key:string]: any}[], field: any) => any[];

const handleField : IHandleField = (values, field) => {
  let fieldExist = false;
  const fields = values.map((el) => {
    if (el.order === field?.order) {
      fieldExist = true;
      return field;
    }
    return el;
  });
  if (fieldExist) {
    return fields;
  }
  return [...values, field];
};

export default handleField;
